export function getAmountButtons(locale, usdtExchangeRate) {
  return usdtExchangeRate?.quick_amounts[locale] || 
    usdtExchangeRate?.quick_amounts['ko'] || 
    []
}
